import { gql, useMutation } from "@apollo/client";
import { PassportOcrResult } from "../../features/process/types/passportOcr";

export const SCAN_PASSPORT = gql`
  mutation scanPassport($imageBase64: String!, $mimeType: String!) {
    scanPassport(imageBase64: $imageBase64, mimeType: $mimeType) {
      surname
      given_names
      nationality
      date_of_birth
      sex
      place_of_birth
      date_of_issue
      date_of_expiry
      passport_number
      issuing_authority
      personal_number
      country_code
      mrz_line1
      mrz_line2
      confidence
      error
      passportScan
    }
  }
`;

export interface ScanPassportData {
  scanPassport: PassportOcrResult;
}

export interface ScanPassportVars {
  imageBase64: string;
  mimeType: string;
}

export const useScanPassport = () =>
  useMutation<ScanPassportData, ScanPassportVars>(SCAN_PASSPORT);
